// useFormatting.js
export function useFormatting() {
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('vi-VN', {style: 'currency', currency: 'VND'}).format(value)
    }

    const formatDateTime = (date) => {
        return new Date(date).toLocaleString('vi-VN', {
            hour: '2-digit',
            minute: '2-digit',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
    }

    const formatDate = (date) => {
        return new Date(date).toLocaleString('vi-VN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
    }

    const formatTime = (time) => {
        return new Date(time).toLocaleTimeString('vi-VN', {hour: '2-digit', minute: '2-digit'})
    }

    const formatMinutes = (minutes) => {
        let time = minutes * 60; // convert to seconds
        const units = {
            h: 3600,
            "'": 60
        };
        let str = '';
        let isTime = false;

        for (const unitName in units) {
            const unitValue = units[unitName];
            const quot = Math.floor(time / unitValue);
            time -= quot * unitValue;

            if (quot > 0) {
                if (!isTime && (unitName === 'h' || unitName === "'")) {
                    isTime = true;
                }

                str += `${quot}${unitName}`;
            }
        }

        return str;
    }

    const formatPaymentMethod = (gateway, method) => {
        const methods = {
            'moveek': {
                'bank-transfer': 'Chuyển khoản / Quét mã QR',
                'moveek-credits': 'Moveek Credits'
            },
            'momo': {
                '': 'Ví MoMo'
            },
            'payoo': {
                'cc': 'Thẻ ATM / Thẻ quốc tế'
            }
        }

        return methods[gateway]?.[method] || ''
    }

    const formatFormat = (value) => {
        const formats = {
            '2d-sub': '2D Phụ Đề',
            '2d-dub': '2D Lồng Tiếng',
            '3d-dub': '3D Lồng Tiếng'
        }

        return formats[value] || value
    }

    return {
        formatCurrency,
        formatDateTime,
        formatDate,
        formatTime,
        formatMinutes,
        formatPaymentMethod,
        formatFormat
    }
}
